<template>
  <v-footer
    color="light-blue darken-3 text-center"
    class="d-flex justify-end py-2 px-2"
    padless
  >
        
    <div 
      class="text-caption  white--text"
>
      <span class="spanVersion">Versão: {{ appVersion }}</span>
    </div>
    <div
      class="white--text pl-4"
    >
      {{ new Date().getFullYear() }} - PRODAM
    </div>
  </v-footer>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "Footer",
  computed: {
    ...mapGetters('common', [ 'appVersion' ]),
  }
};
</script>
<style scoped>
.spanVersion {
  font-size: 0.7em;
}
</style>

